import { gql } from '@apollo/client';
import { PostInformationFragment } from '../../fragments/SearchPostsFragments';
const VIDEO_PERFORMANCE_RAW = `
  query videoPerformance($postsInfo: [ExternalEntityInput!]!, $cumulative: Boolean! = false) {
    posts(postsInfo: $postsInfo) {
      performance: performanceMonthly(cumulative: $cumulative) {
        date
        views
        likes
      }
    }
  }
`;
const VIDEO_PERFORMANCE = gql`
  ${VIDEO_PERFORMANCE_RAW}
`;
const THIRTY_DAY_VIDEO_PERFORMANCE = gql`
  query THIRTY_DAY_VIDEO_PERFORMANCE($postsInfo: [ExternalEntityInput!]!, $cumulative: Boolean! = false) {
    posts(postsInfo: $postsInfo) {
      performance30Days(cumulative: $cumulative) {
        date
        views
        likes
      }
    }
  }
`;
const MODAL_VIDEO_QUERY = gql`
  query MODAL_VIDEO_QUERY($_id: ID!) {
    post(_id: $_id) {
      ...PostInformationFull
    }
  }
  ${PostInformationFragment}
`;
const SAME_CREATOR_VIDEOS_QUERY = gql`
  query SAME_CREATOR_VIDEOS_QUERY($id: String!, $provider: String!) {
    creators(creatorsInfo: { id: $id, provider: $provider }) {
      posts(sort: { field: "engagement", order: "desc" }, size: 4) {
        ...PostInformationFull
      }
    }
  }
  ${PostInformationFragment}
`;
const SAME_TOPIC_VIDEOS_QUERY = gql`
  query SAME_TOPIC_VIDEOS_QUERY($topicIds: [Int!]!, $gt: Float!) {
    searchPosts(
      limit: 4
      query: { topicIds: $topicIds, publishedAt: { gt: $gt } }
      sort: { field: "engagement", order: "desc" }
    ) {
      entities {
        ...PostInformationFull
      }
    }
  }
  ${PostInformationFragment}
`;
export { VIDEO_PERFORMANCE, THIRTY_DAY_VIDEO_PERFORMANCE, MODAL_VIDEO_QUERY, SAME_CREATOR_VIDEOS_QUERY, SAME_TOPIC_VIDEOS_QUERY };